// TradingCalendar.jsx
import React, { useState, useMemo, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import MQSGUtil from "../mqsgUtil";
import './TradingCalendar.css';
import { get } from "lodash";
const TradingCalendar = () => {
  const history = useHistory();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [indexRollover, setIndexRollover] = useState([]);
  const [tooltipIndex, setTooltipIndex] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0, isAbove: false });
  const [tradingDays, setTradingDays] = useState([]); // 存储API返回的交易日
  const tooltipRef = useRef(null);
  // 记录日期市场事件
  const [marketEvent, setMarketEvent] = useState({});
  const [codeList, setCodeList] = useState({})
  const [calendarText, setCalendarText]= useState({})
  // 市场lable
  const marketStatus = [
      { market: 'SGX', status: 'Singapore Market' },
      { market: 'HKG', status: 'Hong Kong Market' },
      { market: 'NYQ', status: 'US Futures Market' },
      { market: 'ROLL', status: 'Index Rollover' },
      { market: 'LAST', status: 'Last Trading Day' }
  ]
  const marketStatusTitle = [
    {status: 'Holiday' },
    {status: 'Others' },
  ]
  
  
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];

  const weekdays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  // 模拟API调用获取交易日数据
  useEffect(() => {
    fetchTradingDays()
  }, []);

  
  const fetchTradingDays = async()=>{
    const url = MQSGUtil.getAPIBasePath() + "/calendar?type=my";
    fetch(url)
      .then((res) => res.json())
      .then((result) => {
        let WarrantSearchResult = result;
        let _lastObj = {} 
        let indexRollover = {};
        // 如果有日历market数据，添加入日历
        if (WarrantSearchResult['dateGroups'] && Array.isArray(WarrantSearchResult['dateGroups'])){
          let _array = [...WarrantSearchResult['dateGroups']]
          for (let index = 0; index < _array.length; index++) {
            const element = _array[index];
            if(element['date'] && Array.isArray(element['items'])){
              let markerList = []
              element['items'].forEach(ele => {
                markerList.push(ele['market_code'])
                // 加入 indexRollover
                if(ele['market_code']=='ROLL'){
                  indexRollover[element['date']] = ele['market_name']?.split(',')
                }
              });
              _lastObj[element['date']]=markerList
            }
          }
        }
        setIndexRollover(indexRollover)
        // 加入 Last Trading Day
        if (WarrantSearchResult['codeList']){
          setCodeList(WarrantSearchResult['codeList'])
          let _lastTradingDay =  Object.keys(WarrantSearchResult['codeList'])
          _lastTradingDay.forEach(item =>{
            if(_lastObj[item]){
              _lastObj[item].push('LAST')
            }else{
              _lastObj[item]=['LAST']
            }
          })
        }
        // 加入底部的text
        let _lastText={}
        let _year = String(currentDate.getFullYear())
        let _month = String(currentDate.getMonth()+1)
        let _lastMonth = String(currentDate.getMonth())
        let _nextMonth = String(currentDate.getMonth()+2)==13?1:String(currentDate.getMonth()+2);
        if(WarrantSearchResult['lastMonthText']){
          _lastText[String(currentDate.getMonth())==0?Number(_year)-1+''+12:_year+_lastMonth]=WarrantSearchResult['lastMonthText']
        }
        if(WarrantSearchResult['currentMonthText']){
          _lastText[_year+_month]=WarrantSearchResult['currentMonthText']
        }
        if(WarrantSearchResult['nextMonthText']){
          _lastText[String(currentDate.getMonth()+2)==13?Number(_year)+1+''+_nextMonth:_year+_nextMonth]=WarrantSearchResult['nextMonthText']
        }
        setCalendarText(_lastText)
        setMarketEvent(_lastObj)
      });
  }

  // 解码
  const decodeHTML = (html) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value;
  };

  // 日期格式化工具函数
  const formatDateKey = (year, month, day) => {
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  };

  // 检查是否为周末 (周六或周日)
  const isWeekend = (year, month, day) => {
    const date = new Date(year, month - 1, day);
    const dayOfWeek = date.getDay();
    return dayOfWeek === 0 || dayOfWeek === 6; // 0 = Sunday, 6 = Saturday
  };

  // 获取市场标记的颜色
  const getMarketColor = (market) => {
    const colors = {
      'HKG': '#F27305',        
      'ROLL': '#cc40b5',    
      'LAST': '#333333',
      'NYQ': '#0F7AC7',
      'SGX': '#cf2938',
    };
    return colors[market] || '#95a5a6';
  };

  // 获取市场标记的CSS类名
  const getMarketClass = (market) => {
    const classes = {
      'HKG': 'hongkong-market',
      'ROLL': 'index-rollover',
      'LAST': 'last-trading-day',
      'NYQ': 'us-market',
      'SGX': 'japan-market',
    };
    return classes[market] || '';
  };

  // 获取市场名称的函数
  const getMarketName = (market) => {
    const names = {
      'HKG': 'Hong Kong Market',
      'ROLL': 'Index Rollover',
      'LAST': 'Last Trading Day',
      'NYQ': 'US Futures Market',
      'SGX': 'Singapore Market',
    };
    return names[market] || market;
  };

  // 检查日期是否有LAST市场标记
  const hasLastMarketMarker = (dateObj) => {
    return dateObj.marketMarkers && dateObj.marketMarkers.includes('LAST') || dateObj.marketMarkers.includes("ROLL");
  };

  // 检查日期是否可点击（有LAST标记且是当前月份）
  const isDateClickable = (dateObj) => {
    return dateObj.isCurrentMonth && hasLastMarketMarker(dateObj);
  };

  // 检查日期是否有Malaysia市场标记
  const hasThaiMarketMarker = (dateObj) => {
    return dateObj.marketMarkers && dateObj.marketMarkers.includes('SGX');
  };

  // 点击外部关闭气泡框
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        const isDateCell = event.target.closest('.calendar-day');
        if (!isDateCell) {
          setSelectedDate(null);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  // 控制页面滚动：气泡框显示时禁用页面滚动
  useEffect(() => {
    if (selectedDate && window.innerWidth < 768) {
      // 禁用页面滚动
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    } else {
      // 恢复页面滚动
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    }

    return () => {
      // 清理：恢复页面滚动
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    };
  }, [selectedDate]);


  // 生成日历数据的函数
  const generateCalendarDays = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();

    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const firstDayOfWeek = firstDay.getDay();
    const daysInMonth = lastDay.getDate();
    const prevMonthLastDay = new Date(year, month, 0).getDate();

    const calendarDays = [];
    let currentWeek = [];

    // 添加上个月的日期
    for (let i = firstDayOfWeek - 1; i >= 0; i--) {
      const day = prevMonthLastDay - i;
      const isWeekendDay = isWeekend(year, month, day);

      currentWeek.push({
        day,
        isCurrentMonth: false,
        isToday: false,
        marketMarkers: [],
        isWeekend: isWeekendDay
      });
    }

    // 添加当月的日期
    for (let day = 1; day <= daysInMonth; day++) {
      const dateObj = new Date(year, month, day);
      const isToday = dateObj.toDateString() === new Date().toDateString();
      const isWeekendDay = isWeekend(year, month + 1, day);

      const dateKey = formatDateKey(year, month + 1, day);
      const marketMarkers = marketEvent[dateKey] || [];
      const isTradingDay = tradingDays.includes(dateKey);

      currentWeek.push({
        day,
        isCurrentMonth: true,
        isToday,
        marketMarkers,
        isTradingDay,
        isWeekend: isWeekendDay
      });

      if (currentWeek.length === 7 || day === daysInMonth) {
        let nextMonthDay = 1;
        while (currentWeek.length < 7) {
          const nextYear = month === 11 ? year + 1 : year;
          const nextMonth = month === 11 ? 0 : month + 1;
          const isWeekendDay = isWeekend(nextYear, nextMonth + 1, nextMonthDay);

          currentWeek.push({
            day: nextMonthDay++,
            isCurrentMonth: false,
            isToday: false,
            marketMarkers: [],
            isWeekend: isWeekendDay
          });
        }
        calendarDays.push([...currentWeek]);
        currentWeek = [];
      }
    }
    return calendarDays;
  };

  // 使用 useMemo 缓存日历数据
  const calendarDays = useMemo(() => {
    return generateCalendarDays(currentDate);
  }, [currentDate, marketEvent,tradingDays]);
  const navigateMonth = (direction) => {
    setSelectedDate(null);
    setCurrentDate(prev => {
      const newDate = new Date(prev);
      const today = new Date();
      const currentMonth = today.getMonth();
      const currentYear = today.getFullYear();
      
      // 获取当月和下月的日期对象
      const thisMonth = new Date(currentYear, currentMonth, 1);
      const nextMonth = new Date(currentYear, currentMonth + 1, 1);
      
      // 根据方向切换月份
      if (direction === 'prev') {
        // 向前切换时，总是回到当月
        return thisMonth;
      } else {
        // 向后切换时，总是切换到下月
        return nextMonth;
      }
    });
  };

  // 键盘导航支持
  const handleKeyPress = (e, direction) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      navigateMonth(direction);
    }
  };

  const handleDateClick = (dateObj, event) => {
    if (!isDateClickable(dateObj)) return;
    const rect = event.currentTarget.getBoundingClientRect();
    const dateKey = formatDateKey(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      dateObj.day
    );
    
    // 设置tooltipIndex - 0: LAST, 1: ROLL, 2: BOTH
    if(dateObj.marketMarkers.includes('LAST') && dateObj.marketMarkers.includes('ROLL')){
      setTooltipIndex(2)
    }else if(dateObj.marketMarkers.includes('LAST')){
      setTooltipIndex(0)
    }else if(dateObj.marketMarkers.includes('ROLL')){
      setTooltipIndex(1)
    }
    
    if (selectedDate === dateKey) {
      setSelectedDate(null);
    } else {
      setSelectedDate(dateKey);
      
      // 获取父容器（dashboard-layout）
      const parentElement = document.querySelector('.dashboard-layout');
      const parentRect = parentElement.getBoundingClientRect();
      
      // 检测是否为移动设备
      const isMobile = window.innerWidth < 768;
      
      if (isMobile) {
        // 移动设备：使用absolute定位固定在屏幕中间（相对于父容器）
        const centerX = parentRect.width / 2;
        const centerY = parentRect.height / 2;
        
        setTooltipPosition({
          x: centerX,
          y: centerY,
          isAbove: false,
          isMobile: true
        });
      } else {
        // 桌面设备：显示在日期上方或下方
        const relativeX = rect.left - parentRect.left + rect.width / 2;
        const relativeY = rect.top - parentRect.top;
        const relativeBottomY = rect.bottom - parentRect.top;
        
        // 检查上方和下方空间
        const spaceAbove = rect.top;
        const spaceBelow = window.innerHeight - rect.bottom;
        
        // 决定气泡框显示位置
        const minSpace = 150;
        const isAbove = spaceBelow < minSpace && spaceAbove >= minSpace / 2;
        
        setTooltipPosition({
          x: relativeX,
          y: isAbove ? relativeY : relativeBottomY,
          isAbove,
          isMobile: false
        });
      }
    }
  };

  const handleTouchStart = (dateObj, event) => {
    if (!isDateClickable(dateObj)) return;
    event.preventDefault();
    event.stopPropagation();
    handleDateClick(dateObj, event);
  };

  // 渲染日历日期的通用函数 - 已修改：TH市场标记不显示小圆点，其他市场正常显示
  const renderCalendarDay = (dateObj, weekIndex, dayIndex) => {
    const isClickable = isDateClickable(dateObj);
    const hasThaiMarket = hasThaiMarketMarker(dateObj);

    // 只有有泰国市场标记的日期才使用泰国市场的颜色作为背景
    const thaiMarketStyle = hasThaiMarket ? {
      background: '#5ec6a5',
      color: 'white'
    } : {};

    // 过滤掉TH市场标记，只显示其他市场的标记
    const otherMarketMarkers = dateObj.marketMarkers.filter(market => market !== 'SGX');

    return (
      <div
        key={`${weekIndex}-${dayIndex}`}
        className={`calendar-day ${dateObj.isToday ? 'today' : ''
          } ${dateObj.isTradingDay ? 'trading-day' : ''
          } ${!dateObj.isCurrentMonth ? 'other-month' : ''
          } ${dateObj.isWeekend ? 'weekend' : ''
          } ${isClickable ? 'clickable' : 'non-clickable'}`}
        style={thaiMarketStyle}
        onClick={(e) => {
          // 在移动设备上禁用点击事件，只响应触摸事件
          // 避免触摸事件和点击事件同时触发导致闪烁
          if (window.innerWidth >= 768) {
            handleDateClick(dateObj, e);
          }
        }}
        onTouchStart={(e) => handleTouchStart(dateObj, e)}
        tabIndex={isClickable ? 0 : -1}
        onKeyDown={(e) => {
          if ((e.key === 'Enter' || e.key === ' ') && isClickable) {
            e.preventDefault();
            handleDateClick(dateObj, e);
          }
        }}
        aria-label={`${dateObj.isCurrentMonth ? monthNames[currentDate.getMonth()] : 'Other month'} ${dateObj.day}${dateObj.isToday ? ', Today' : ''}${dateObj.isTradingDay ? ', Trading day' : ''}${dateObj.marketMarkers.length > 0 ? `, Markets: ${dateObj.marketMarkers.map(m => getMarketName(m)).join(', ')}` : ''}`}
      >
        <div className="day-number" style={{ color: hasThaiMarket ? 'white' : '#2d3748' }}>
          {dateObj.day}
        </div>

        {/* 市场标记 - 显示除TH之外的其他市场标记 */}
        {otherMarketMarkers.length > 0 && (
          <div className="market-markers">
            {otherMarketMarkers.map((market, index) => (
              <div
                key={index}
                className={`market-marker ${getMarketClass(market)}`}
                style={{ backgroundColor: getMarketColor(market) }}
                title={getMarketName(market)}
                aria-label={`${getMarketName(market)} market`}
              ></div>
            ))}
          </div>
        )}

        {dateObj.isTradingDay && (
          <div className="trading-indicator" aria-label="Trading day"></div>
        )}
      </div>
    );
  };

  // 计算当前月份相关日期
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  const thisMonth = new Date(currentYear, currentMonth, 1);
  const nextMonth = new Date(currentYear, currentMonth + 1, 1);
  
  // 检查当前显示的是哪个月
  const isThisMonth = currentDate.getMonth() === thisMonth.getMonth() && currentDate.getFullYear() === thisMonth.getFullYear();
  const isNextMonth = currentDate.getMonth() === nextMonth.getMonth() && currentDate.getFullYear() === nextMonth.getFullYear();
  
  return (
    <div className="dashboard-layout">
      {/* 气泡框 */}
      {selectedDate && (
        <div
          ref={tooltipRef}
          className={`trading-tooltip ${tooltipPosition.isAbove ? 'tooltip-above' : 'tooltip-below'}`}
          style={{
            // 移动设备：直接设置在屏幕中心
            left: tooltipPosition.isMobile ? '50%' : `${tooltipPosition.x}px`,
            top: tooltipPosition.isMobile ? '50%' : `${tooltipPosition.y}px`,
            // 移动设备使用fixed定位确保始终居中
            position: tooltipPosition.isMobile ? 'fixed' : 'absolute',
            // 居中对齐
            transform: tooltipPosition.isMobile 
              ? 'translate(-50%, -50%)' // 移动设备：屏幕中心
              : `translateX(-50%) ${tooltipPosition.isAbove ? 'translateY(-100%)' : 'translateY(0)'}`, // 桌面设备：上方或下方
            zIndex: 1000,
            // 移除所有margin
            margin: 0,
            // 移动设备优化
            maxWidth: tooltipPosition.isMobile ? '90vw' : '80vw',
            minWidth: tooltipPosition.isMobile ? '250px' : '230px',
            width: tooltipPosition.isMobile ? '90vw' : 'auto',
            // 确保气泡框不超出视口
            maxHeight: '30vh',
            overflowY: 'auto',
            backgroundColor: 'white',
            border: '1px solid #ddd',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
            // 允许气泡框内部垂直滚动
            touchAction: 'pan-y',
          }}
          role="tooltip"
          aria-live="polite"
          onTouchStart={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onTouchMove={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onTouchCancel={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div className="tooltip-header TradingCalendarTooltipHead">
            {tooltipIndex===0&&'Last Trading Day'}
            {tooltipIndex===1&&'Index Rollover'}
            {tooltipIndex===2&&'Last Trading Day & Index Rollover'}
          </div>
          <div className="tooltip-content">
            {tooltipIndex===0 && codeList[selectedDate] && codeList[selectedDate].map((code, index) => {
              const ticker = typeof code === 'object' ? code.ticker : code;
              const name = typeof code === 'object' ? code.name : null;
              return (
                <div key={index} className="tooltip-code-item" style={{ "cursor": "pointer"}}
                  onTouchEnd={(e) => {
                    e.stopPropagation();
                    history.push('/tools/livematrix/' + ticker);
                  }}
                  onClick={() => history.push('/tools/livematrix/' + ticker)}
                >
                  
                  {name && <span style={{ marginRight: "8px" }}>{name}</span>}
                  <span>({ticker})</span>
                </div>
              );
            })}
            {tooltipIndex===1 && indexRollover[selectedDate] && indexRollover[selectedDate].map((code, index) => (
              <div key={index} className="tooltip-code-item"
              >
                {code}
              </div>
            ))}
            {tooltipIndex===2 && (
              <>
                {codeList[selectedDate] && (
                  <div className="tooltip-section">
                    <div className="tooltip-section-title TradingCalendarSectionHead">Last Trading Day</div>
                    {codeList[selectedDate].map((code, index) => {
                      const ticker = typeof code === 'object' ? code.ticker : code;
                      const name = typeof code === 'object' ? code.name : null;
                      return (
                        <div key={index} className="tooltip-code-item" style={{"margin-bottom":"5px", "cursor": "pointer"}}
                          onTouchEnd={(e) => {
                            e.stopPropagation();
                            history.push('/tools/livematrix/' + ticker);
                          }}
                          onClick={() => history.push('/tools/livematrix/' + ticker)}
                        >
                          
                          {name && <span style={{ marginRight: "8px" }}>{name}</span>}
                          <span>({ticker})</span>
                        </div>
                      );
                    })}
                  </div>
                )}
                {indexRollover[selectedDate] && (
                  <div className="tooltip-section">
                    <div className="tooltip-section-title TradingCalendarSectionHead">Index Rollover</div>
                    {indexRollover[selectedDate].map((code, index) => (
                      <div key={index} className="tooltip-code-item" style={{"margin-bottom":"5px"}}
                      >
                        {code}
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
          {/* 仅在非移动设备上显示箭头 */}
          {!tooltipPosition.isMobile && (
            <div className={`tooltip-arrow ${tooltipPosition.isAbove ? 'arrow-below' : 'arrow-above'}`}></div>
          )}
        </div>
      )}
      {/* 右上角面板 - Line */}
        <div className="dashboard-panel top-right-panel"> 
          <div className='page-header' style={{marginTop: 0}}>
          <h1 className='small'>Calendar</h1>
        </div>
        <div className="panel-header calendar-panel-header">
          {/* 修改：将Line标题放在导航上方 */}
          <div className="calendar-navigation">
            {/* 左箭头 - 只在当前显示的是下个月时可见 */}
            <button
              className="nav-btn"
              onClick={() => navigateMonth('prev')}
              onKeyDown={(e) => handleKeyPress(e, 'prev')}
              aria-label="Previous month"
              style={{ visibility: isNextMonth ? 'visible' : 'hidden' }}
            >
              ‹
            </button>
            <h2 className="month-year">
              {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
            </h2>
            {/* 右箭头 - 只在当前显示的是当月时可见 */}
            <button
              className="nav-btn"
              onClick={() => navigateMonth('next')}
              onKeyDown={(e) => handleKeyPress(e, 'next')}
              aria-label="Next month"
              style={{ visibility: isThisMonth ? 'visible' : 'hidden' }}
            >
              ›
            </button>
          </div>
        </div>
        <div className="panel-content">
          <div className="trading-calendar">
            <div className="calendar-container">
              <div className="calendar-content">
                {/* 日历部分 */}
                <div className="calendar-section">
                  {/* 星期标题 */}
                  <div className="weekdays">
                    {weekdays.map(day => (
                      <div key={day} className="weekday">{day}</div>
                    ))}
                  </div>
                  {/* 日历网格 */}
                  <div className="calendar-grid">
                    <div className="calendar-weeks-container">
                      {calendarDays.map((week, weekIndex) => (
                        <div key={weekIndex} className="calendar-week">
                          {week.map((dateObj, dayIndex) =>
                            renderCalendarDay(dateObj, weekIndex, dayIndex)
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className='line'></div>
                  {/* 市场状态 */}
                  <div className="market-status" style={{position:'relative'}}>
                    {marketStatus.map((item, index) => {
                      // 如果是 NYQ 且 marketEvent 中不包含 NYQ，则不展示
                      if (item.market === 'NYQ' && !Object.values(marketEvent)?.some(arr => arr?.includes('NYQ'))) {
                        return (<div key={index} style={{display:'none'}}></div>);
                      }
                      // 如果是 HKG 且 marketEvent 中不包含 HKG，则不展示
                      if (item.market === 'HKG' && !Object.values(marketEvent)?.some(arr => arr?.includes('HKG'))) {
                        return (<div key={index} style={{display:'none'}}></div>);
                      }
                      return (
                        <>
                          {index == 0 &&<div className='market-status-title' key={index+'_'} style={{clear: 'both',fontSize:'20px',fontWeight: 'bold'}} >{marketStatusTitle[0].status}</div>}
                          {index == 3 &&<div className='market-status-title' key={index+'_'} style={{clear: 'both',fontSize:'20px',fontWeight: 'bold'}} >{marketStatusTitle[1].status}</div>}
                          <div key={index} className="status-item">
                            <span className="market-code"></span>
                            <span className="status-text">{item.status}</span>
                          </div>
                        </>
                      );
                    })}
                  </div>
                  {/* 文本框 */}
                  {calendarText[String(currentDate.getFullYear())+String(currentDate.getMonth()+1)] && (
                    <div className='text_box'>
                      <divs style={{wordBreak: 'break-word'}}
                        dangerouslySetInnerHTML={{ __html: decodeHTML(calendarText[String(currentDate.getFullYear())+String(currentDate.getMonth()+1)]) }}
                      />
                    </div>
                  )}
                  {/* <div className='text_box'>
                    {String(currentDate.getFullYear())+""+String(currentDate.getMonth())}
                    {calendarText[String(currentDate.getFullYear())+String(currentDate.getMonth())]?calendarText[String(currentDate.getFullYear())+String(currentDate.getMonth())].innerHTML():''}
                  </div> */}
                    {/* <p>Us:nnrdnñny</p>
                    <p>6alaamwndove:lUauisnglaanwndov DW 5100ula=йuúvounanprulnulla=/nSodiwus:inalu5unuavosnanarudu9ln 0o,
                      3nlu0san35,ro0dqllaanTwasexv:nduuglednwnde0nuUnmiusunisalUvexfonanpruuun la*naTnrulne</p>
                    <p>6alaamwndove:lUauisnglaanwndov DW 5100ula=йuúvounanprulnulla=/nSodiwus:inalu5unuavosnanarudu9ln 0o,
                      3nlu0san35,ro0dqllaanTwasexv:nduuglednwnde0nuUnmiusunisalUvexfonanpruuun la*naTnrulne</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingCalendar;